import { jsx, jsxs } from "react/jsx-runtime";
import { isPositionWithinRange } from "@teselagen/range-utils";
import assign from "lodash/assign";
import React from "react";
import areNonNegativeIntegers from "validate.io-nonnegative-integer-array";
import { getOverlapsOfPotentiallyCircularRanges } from "@teselagen/range-utils";
import getXStartAndWidthOfRangeWrtRow from "./getXStartAndWidthOfRangeWrtRow";
import { pureNoFunc } from "@teselagen/ui";
import { connectToEditor } from "../withEditorProps";
let snipStyle = {
  height: "100%",
  // background: 'black',
  position: "absolute",
  width: "2px"
};
let snipConnectorStyle = {
  height: "2px",
  // background: 'black',
  position: "absolute",
  top: -1
};
function getSnipForRow(isTopStrand, isHovered, snipPosition, row, sequenceLength, bpsPerRow, snipStyle2, charWidth, index) {
  if (!isPositionWithinRange(snipPosition, row)) return;
  const { xStart } = getXStartAndWidthOfRangeWrtRow({
    range: { start: snipPosition, end: snipPosition },
    row,
    charWidth,
    sequenceLength
  });
  const newCursorStyle = assign({}, snipStyle2, {
    left: xStart
  });
  const cursorEl = /* @__PURE__ */ jsx(
    "div",
    {
      className: `veRowViewCutsite snip ${isTopStrand ? "topStrandSnip" : "bottomStrandSnip"} ${isHovered ? "snipHovered" : ""} snipPosition-${snipPosition}`,
      style: newCursorStyle
    },
    index
  );
  return cursorEl;
}
function getSnipConnector(isHovered, snipRange, row, sequenceLength, bpsPerRow, snipConnectorStyle2, charWidth, index) {
  const overlaps = getOverlapsOfPotentiallyCircularRanges(
    snipRange,
    { ...row, end: row.end + 1 },
    sequenceLength
  );
  return overlaps.map(function(overlap, index2) {
    let { xStart, width } = getXStartAndWidthOfRangeWrtRow({
      range: overlap,
      row,
      charWidth,
      sequenceLength
    });
    width -= charWidth;
    const newCursorStyle = assign({}, snipConnectorStyle2, {
      left: xStart,
      width
    });
    const cursorEl = /* @__PURE__ */ jsx(
      "div",
      {
        className: `veRowViewCutsite snipConnector ${isHovered ? "snipHovered" : ""} `,
        style: newCursorStyle
      },
      index + index2
    );
    return cursorEl;
  });
}
function Cutsites(props) {
  const {
    annotationRanges,
    charWidth,
    bpsPerRow,
    row,
    sequenceLength,
    topStrand,
    hoveredAnnotation
  } = props;
  const snips = [];
  const snipConnectors = [];
  Object.keys(annotationRanges).sort(
    (a) => annotationRanges[a].annotation.id === hoveredAnnotation ? 1 : -1
  ).forEach(function(key) {
    const annotationRange = annotationRanges[key];
    let { annotation } = annotationRange;
    if (!annotation) {
      annotation = annotationRange;
    }
    let {
      topSnipPosition,
      bottomSnipPosition,
      upstreamBottomSnip,
      upstreamTopSnip,
      upstreamTopBeforeBottom,
      topSnipBeforeBottom
    } = annotation;
    topSnipPosition = topSnipPosition && Number(topSnipPosition);
    bottomSnipPosition = bottomSnipPosition && Number(bottomSnipPosition);
    upstreamTopSnip = upstreamTopSnip && Number(upstreamTopSnip);
    upstreamBottomSnip = upstreamBottomSnip && Number(upstreamBottomSnip);
    const isHovered = annotation.id === hoveredAnnotation;
    const color = (annotation.isImportant ? "black" : annotation.color) || annotation.restrictionEnzyme?.color || "black";
    snipStyle = {
      ...snipStyle,
      background: color
    };
    snipConnectorStyle = {
      ...snipConnectorStyle,
      background: color
    };
    let newSnip;
    let newConnector;
    const snipRange = {};
    if (areNonNegativeIntegers([bottomSnipPosition, topSnipPosition])) {
      if (topStrand) {
        newSnip = getSnipForRow(
          true,
          isHovered,
          topSnipPosition,
          row,
          sequenceLength,
          bpsPerRow,
          snipStyle,
          charWidth,
          key + "downstream"
        );
        if (newSnip) {
          snips.push(newSnip);
        }
      } else {
        newSnip = getSnipForRow(
          false,
          isHovered,
          bottomSnipPosition,
          row,
          sequenceLength,
          bpsPerRow,
          snipStyle,
          charWidth,
          key + "downstream"
        );
        if (newSnip) {
          snips.push(newSnip);
        }
        if (topSnipBeforeBottom) {
          snipRange.start = topSnipPosition;
          snipRange.end = bottomSnipPosition;
        } else {
          snipRange.start = bottomSnipPosition;
          snipRange.end = topSnipPosition;
        }
        newConnector = getSnipConnector(
          isHovered,
          snipRange,
          row,
          sequenceLength,
          bpsPerRow,
          snipConnectorStyle,
          charWidth,
          key + "downstreamConnector"
        );
        snipConnectors.push(newConnector);
      }
    }
    if (areNonNegativeIntegers([upstreamBottomSnip, upstreamTopSnip])) {
      if (topStrand) {
        newSnip = getSnipForRow(
          true,
          isHovered,
          upstreamTopSnip,
          row,
          sequenceLength,
          bpsPerRow,
          snipStyle,
          charWidth,
          key + "upstream"
        );
        if (newSnip) {
          snips.push(newSnip);
        }
      } else {
        newSnip = getSnipForRow(
          false,
          isHovered,
          upstreamBottomSnip,
          row,
          sequenceLength,
          bpsPerRow,
          snipStyle,
          charWidth,
          key + "upstream"
        );
        if (newSnip) {
          snips.push(newSnip);
        }
        if (upstreamTopBeforeBottom) {
          snipRange.start = upstreamTopSnip;
          snipRange.end = upstreamBottomSnip;
        } else {
          snipRange.start = upstreamBottomSnip;
          snipRange.end = upstreamTopSnip;
        }
        newConnector = getSnipConnector(
          isHovered,
          snipRange,
          row,
          sequenceLength,
          bpsPerRow,
          snipConnectorStyle,
          charWidth,
          key + "upstreamConnector"
        );
        snipConnectors.push(newConnector);
      }
    }
  });
  return /* @__PURE__ */ jsxs("div", { children: [
    snips,
    snipConnectors
  ] });
}
export default pureNoFunc(
  connectToEditor(({ hoveredAnnotation }) => ({
    hoveredAnnotation
  }))(Cutsites)
);
